"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = undefined;

var _dec, _class;

require("source-map-support/register");

var _tsyringe = require("tsyringe");

var singleton = _tsyringe.singleton;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var PromiseTimeout = (_dec = singleton(), _dec(_class = /*#__PURE__*/function () {
  function PromiseTimeout() {
    _classCallCheck(this, PromiseTimeout);
  }

  _createClass(PromiseTimeout, null, [{
    key: "timeout",
    value: function timeout(ms, promise, eventCallback) {
      var id;
      var timeout = new Promise(function (resolve) {
        id = setTimeout(function () {
          resolve(eventCallback());
        }, ms);
      });
      return Promise.race([promise, timeout]).then(function (result) {
        clearTimeout(id);
        return result;
      });
    }
  }]);

  return PromiseTimeout;
}()) || _class);
exports["default"] = PromiseTimeout;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9IZWxwZXIvUHJvbWlzZVRpbWVvdXQudHMiXSwibmFtZXMiOlsic2luZ2xldG9uIiwiUHJvbWlzZVRpbWVvdXQiLCJtcyIsInByb21pc2UiLCJldmVudENhbGxiYWNrIiwiaWQiLCJ0aW1lb3V0IiwiUHJvbWlzZSIsInJlc29sdmUiLCJzZXRUaW1lb3V0IiwicmFjZSIsInRoZW4iLCJyZXN1bHQiLCJjbGVhclRpbWVvdXQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7O0FBQUE7O0lBQVNBLFMsYUFBQUEsUzs7Ozs7Ozs7SUFHWUMsYyxXQURwQkQsU0FBUyxFOzs7Ozs7OzRCQUdORSxFLEVBQ0FDLE8sRUFDQUMsYSxFQUNjO0FBQ2QsVUFBSUMsRUFBSjtBQUNBLFVBQU1DLE9BQU8sR0FBRyxJQUFJQyxPQUFKLENBQVksVUFBQ0MsT0FBRCxFQUFhO0FBQ3ZDSCxRQUFBQSxFQUFFLEdBQUdJLFVBQVUsQ0FBQyxZQUFNO0FBQ3BCRCxVQUFBQSxPQUFPLENBQUNKLGFBQWEsRUFBZCxDQUFQO0FBQ0QsU0FGYyxFQUVaRixFQUZZLENBQWY7QUFHRCxPQUplLENBQWhCO0FBTUEsYUFBT0ssT0FBTyxDQUFDRyxJQUFSLENBQWEsQ0FDbEJQLE9BRGtCLEVBRWxCRyxPQUZrQixDQUFiLEVBR0pLLElBSEksQ0FHQyxVQUFDQyxNQUFELEVBQVk7QUFDbEJDLFFBQUFBLFlBQVksQ0FBQ1IsRUFBRCxDQUFaO0FBQ0EsZUFBT08sTUFBUDtBQUNELE9BTk0sQ0FBUDtBQU9EOzs7OztxQkFwQmtCWCxjIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgc2luZ2xldG9uIH0gZnJvbSAndHN5cmluZ2UnO1xuXG5Ac2luZ2xldG9uKClcbmV4cG9ydCBkZWZhdWx0IGNsYXNzIFByb21pc2VUaW1lb3V0IHtcbiAgcHVibGljIHN0YXRpYyB0aW1lb3V0KFxuICAgIG1zOiBudW1iZXIsXG4gICAgcHJvbWlzZTogUHJvbWlzZTxhbnk+LFxuICAgIGV2ZW50Q2FsbGJhY2s6IEZ1bmN0aW9uLFxuICApOiBQcm9taXNlPGFueT4ge1xuICAgIGxldCBpZDogYW55O1xuICAgIGNvbnN0IHRpbWVvdXQgPSBuZXcgUHJvbWlzZSgocmVzb2x2ZSkgPT4ge1xuICAgICAgaWQgPSBzZXRUaW1lb3V0KCgpID0+IHtcbiAgICAgICAgcmVzb2x2ZShldmVudENhbGxiYWNrKCkpO1xuICAgICAgfSwgbXMpO1xuICAgIH0pO1xuXG4gICAgcmV0dXJuIFByb21pc2UucmFjZShbXG4gICAgICBwcm9taXNlLFxuICAgICAgdGltZW91dCxcbiAgICBdKS50aGVuKChyZXN1bHQpID0+IHtcbiAgICAgIGNsZWFyVGltZW91dChpZCk7XG4gICAgICByZXR1cm4gcmVzdWx0O1xuICAgIH0pO1xuICB9XG59XG4iXX0=